import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReimbursementService } from '../reimbursement.service';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
@Component({
  selector: 'app-reimbursement-manager-items-list',
  templateUrl: './reimbursement-manager-items-list.component.html',
  styleUrls: ['./reimbursement-manager-items-list.component.css']
})
export class ReimbursementManagerItemsListComponent implements OnInit {
  userData;
  sub;
  id;
  date;
  user;
  reimbursement_manager;
  accepted;
  constructor(private reimbur: ReimbursementService,
    private location: Location, private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    public router: Router, private flashService: FlashService,
  ) {
    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "paid") {
          this.accepted = status.key;

        }
      });
    });
  }

  ngOnInit() {
    this.userData = this.reimbur.reimbursementUserList;
    this.userData.items.forEach(data => {
      this.date = data.date;
    });
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
    });
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.user.roles.forEach(roles => {
      if (roles == 'reimbursement_manager') {
        this.reimbursement_manager = roles;
      }
    });
  }

  locationBack() {
    this.location.back();
  }
  goToFile(url) {
    window.location.replace(url);
  }
  downloadReport(reimbursementId) {
    this.spinnerService.show();
    this.reimbur.getReportFile(reimbursementId).subscribe((blob: Blob) => {
      this.spinnerService.hide();

      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }, error => {
      this.spinnerService.hide();
    });
  }
  trackByFn(index) {
    return index;
  }
  managerAccept(id, data) {
    let final = {
      items: []
    }
    data.items.forEach(itemsData => {
      const itemsPayload = {
        _id: itemsData._id,
        approval_cost: itemsData.cost
      }
      final.items.push(itemsPayload);
    });

    this.reimbur.getAccept(final, id, this.accepted).subscribe(accepted => {
      this.flashService.show(accepted['message'], 'alert-success');
      this.router.navigate(['/reimbursement/manager/list']);
    });

  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-items-list/reimbursement-manager-items-list.component.ts